<template>
  <vs-popup class="raw-material-stock-adjust-activity-log-pop-up"
            id="popup"
            title="RAW MATERIAL STOCK INVENTORY LOG"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div id="sundry-item-list-table" slot="no-body" class="mt-4" v-can="'view-raw-material-stock-adjust-log'">
        <vs-table
          v-if="is_loaded"
          :max-items="(meta.per_page) ? meta.per_page : 10"
          :data="logs"
          sort
          :sst="true"
          stripe class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th class="text-xs">DATE/TIME</vs-th>
            <vs-th class="text-xs">USER</vs-th>
            <vs-th class="text-xs">CHANGE TYPE</vs-th>
            <vs-th class="text-xs">CHANGE QTY (KG)</vs-th>
            <vs-th class="text-xs">PRICE (KG/GBP)</vs-th>
            <vs-th class="text-xs">CHANGE SUM (GBP)</vs-th>
            <vs-th class="text-xs">REASON FOR CHANGE</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr  class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


              <vs-td :data="data[indextr].created_at">
                {{ __dateTimeFormatter(data[indextr].created_at)}}
              </vs-td>

              <vs-td :data="data[indextr].causer_name">
                {{ data[indextr].causer_name}}
              </vs-td>

              <vs-td :data="data[indextr].description">
                <vs-chip transparent :color="data[indextr].description === 'updated' ? 'warning' : 'primary'">
                  {{ data[indextr].description}}
                </vs-chip>
              </vs-td>

              <vs-td :data="data[indextr].change_quantity">
                {{ data[indextr].change_quantity || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].price">
                {{ data[indextr].price || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].change_sum">
                {{ data[indextr].change_sum || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].properties.reason_for_change">
                {{ data[indextr].properties.reason_for_change}}
              </vs-td>

              <template class="expand-user" slot="expand">
                <div class="con-expand-users w-full">
                  <div class="vx-row">
                    <div class="vx-col w-full p-16">
                      <vs-table noDataText="" class="w-full">
                        <template slot="thead">
                          <vs-th>CHANGED FIELD</vs-th>
                          <vs-th>PREVIOUS VALUE</vs-th>
                          <vs-th>NEW VALUE</vs-th>
                        </template>
                        <template>
                          <vs-tr :key="name" v-for="(item, name) in data[indextr].properties.attributes">
                            <vs-td>{{ underScoreRemove(name) }}</vs-td>
                            <vs-td>{{tr.properties.old[name]}}</vs-td>
                            <vs-td>{{tr.properties.attributes[name]}}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </template>


            </vs-tr>
          </template>


        </vs-table>

        <vs-pagination
          v-if="is_loaded"
          v-on:changeMaxItems="changePage"
          :size-array="meta.total ? meta.total : 20"
          :max-items="perPage"
          description-body="Rows per page"
          description-connector="of"
          description-title="Records"
          description
          :description-items="descriptionItems"
          :total="(meta.last_page)? meta.last_page : 0"
          v-model="page"  class="p-5">
        </vs-pagination>


      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ActivityRepository = RepositoryFactory.get('activity')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  function initialState() {
    return {
      open: false,
      is_loaded: false,
      id: '',
      logs: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  }

export default {
  name: 'RawMaterialStockAdjustLogPopup',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
      } catch (error) {
      }
    },
    async fetchSundryItemStockList() {
      await this.$vs.loading()
      try {
        const {data} = await ActivityRepository.getRawMaterialStockInventoryLog(this.id, this.page, this.perPage)
        this.logs =  data.data
        this.meta = data
        this.is_loaded = true
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close()
    },
    underScoreRemove(string) {
      return string.replaceAll("_", " ");
    },
    filterQueryUpdate (){
      if (this.id) {
        this.fetchSundryItemStockList()
      }
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchSundryItemStockList()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchSundryItemStockList()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted () {
  },
  mixins : [Filter, SuccessMessage, ErrorMessages],
  watch : {
    page(){
      this.fetchSundryItemStockList()
    },
    perPage() {
      this.fetchSundryItemStockList()
    }
  }
}
</script>

<style scoped>
  .raw-material-stock-adjust-activity-log-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
